import API from '../apiCreate'
import { ResponseWrapper } from '../types/base.types'

export interface SupportSurvey {
  id: number
  periodFrom: number
  periodUntil: number
  stats: {
    users: number | null
    lessons: number | null
    homeworks: number | null
    paymentsAmount: number | null
  }
}

export const supportSurveyApi = {
  pending: () =>
    API.get<ResponseWrapper<SupportSurvey | null>>('support-survey/pending'),
  submit: (id: number, rating: number, comment: string) =>
    API.post<ResponseWrapper<{ submitted: boolean }>>('support-survey/submit', {
      id,
      rating,
      comment,
    }),
}
